import { ReloadLicenseUsecase } from './Reload'

export class LoadLicenseUsecase extends ReloadLicenseUsecase {
    loadLicense (): VoidFunction | void {
        void this.reloadLicense()
        return () => this.setState({ license: null })
    }
}
